import './v3/style.css';
import { mountApp } from './v3/app';

mountApp();
